export default __webpack_public_path__ + "static/char-s-32-zh-Hans-376086bce71f620bca1c82555a3c481d.webp";